import { AnimationDiv } from "./style"

export const AnimateFrame = ({children}) => {
  return(
    <AnimationDiv>
      {children}
    </AnimationDiv>
  )
}